import { useTranslation } from 'react-i18next';

// Faste værdier under "Til" på begivenheder: +1/+2/+3 timer fra starttid, eller resten af dagen.
// Sluttiden afgør hvor længe bilen er blokeret for udlejning (Kennith 2026-10-14).
// restOfDay = true → kalderen bør ikke regne "tid brugt" ud fra 23:59.
export default function QuickEndTime({ start, onPick }: {
  start: string;
  onPick: (end: string, restOfDay: boolean) => void;
}) {
  const { t } = useTranslation();
  const plus = (hours: number) => {
    const [h, m] = start.split(':').map(Number);
    const total = Math.min(h * 60 + m + hours * 60, 23 * 60 + 59);  // aldrig over midnat
    return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
  };
  const btn = 'btn btn-secondary px-2 py-0.5 text-xs';
  return (
    <div className="flex flex-wrap gap-1.5 mt-1.5">
      {[1, 2, 3].map(h => (
        <button key={h} type="button" disabled={!start} className={btn}
          title={!start ? t('events.quick_end_needs_start') : undefined}
          onClick={() => onPick(plus(h), false)}>
          {t('events.quick_end_hours', { count: h })}
        </button>
      ))}
      <button type="button" className={btn} onClick={() => onPick('23:59', true)}>
        {t('events.quick_end_rest_of_day')}
      </button>
    </div>
  );
}
